<template>
    <div class="processing list-box">
        <div class="tree">
            <Tree @changeSwitch="changeSwitch" :switchVal="isDown" @nodeClick="nodeClick"></Tree>
        </div>
        <div class="right-box">
            <TableSearch :search-config="searchConfig" :search-params="searchParams" @resetCallBack="reset()"  @search="search"></TableSearch>
            <Table :tabelButtons="tabelButtons" :table-config="tableConfig" :pagination="pagination" :template-data="tableData"></Table>
        </div>
        <el-dialog
                class="info-box"
                title="报警详情"
                :visible.sync="dialogVisible"
                width="40%">
            <AlarmDetailBox :alarm-detail-data="alarmInfo"></AlarmDetailBox>
        </el-dialog>
    </div>
</template>

<script>
    import AlarmDetailBox from '../alarm-detail-box/alarm-detail-box'
    import Tree from '@/components/Tree/nodeTree';
    import {listAPI} from '@/api-path/command-center.js'
    export default {
        name: "processing",
        components: {
            Tree,
            AlarmDetailBox
        },
        data() {
            return {
                isDown: false, // 是否查询下级
                dialogVisible: false,
                searchConfig: {
                    dataName: 'searchParams',
                    items: [
                        {
                            placeholder: '输入姓名搜索',
                            key: 'search',
                        }, {
                            placeholder: '开始时间:结束时间',
                            valueType: 'datetimerange',
                            key: 'date'
                        }
                    ]
                },
                searchParams: {
                    areaId: '', // 区域ID
                    status: '2', // 事件状态
					search:'',
                    userId: sessionStorage.getItem('userId'), // 用户Id
                    date: [],
                    page: 1,
                    size: 15,
                },
				tabelButtons:[],
                tableConfig: {
                    rows: [
                        {
                            label: '报警时间',
                            prop: 'happenDate',
							type:"popover",
                        }, {
                            label: '报警人',
                            prop: 'userName',
							type:"popover",
                        }, {
                            label: '处理人',
                            prop: 'dealName',
							type:"popover",
                        }, {
                            label: '区域',
                            prop: 'areaName',
                        }, {
                            label: '接警中心',
                            prop: 'centerName',
                        }, {
                            label: '接警来源',
                            // width: '80px',
                            prop: 'sourceName',
                        }, {
                            label: '报警方式',
                            prop: 'alarmType',
                        }, {
                            label: '报警内容',
                            prop: 'content',
                        }, {
                            label: '报警地点',
                            prop: 'address',
							width:'100px',
							type:"popover",
                        }, {
                            label: '状态',
                            prop: 'statusName',
                        },{
							label:'是否超时',
							prop:'overdueTime',
							type:'status',
							activeColor:'red',
							activeText:'已超时',
							text:"正常",
						}
                    ],
                    rowButtons: {
                        // width: '180px',
                        items: [
                            {
                                show: `centerUserId !== "${sessionStorage.getItem('userId')}" ? show: false`,
                                label: '查看',
								color:"#80CBF3",
                                fn:  this.getAlarmDetail
                            }, {
                                show: `centerUserId === "${sessionStorage.getItem('userId')}" ? show: false`,
                                label: '处理',
                                fn: (data) => {
                                    this.goDetail(data)
                                }
                            },
                        ]
                    },
                },
                tableData: [],
                pagination: {
                    show: true,
                    page: 1,
                    size: 15,
                    total: 0,
                    sizeChange: (size) => {
                        this.pagination.size = size
                        this.searchParams.size = size
                        this.search()
                    },
                    pageChange: (page) => {
                        this.pagination.page = page
                        this.searchParams.page = page
                        this.search()
                    },
                },
                alarmInfo: {},
            }
        },
       computed:{
       	newAlarm(){
       		return this.$store.state.hasNewAlarm//新的报警
       	}
       },
       watch:{
       	newAlarm(newVal,oldVal){
       		if(newVal){
       			this.search();
       		}
       	}
       },
		methods: {
            search() {
                const {date, ...params} = {...this.searchParams}
                params.startTime = date[0]
                params.endTime = date[1]
                params.isDown = this.isDown
                this.$http.get(listAPI.list, {params}).then(res => {
                    res.result.pageList.map(item => {
                        item.alarmSource = this.matchFn.matchCodeName('ALARM_SOURCE', item.alarmSource)
                        item.alarmType = this.matchFn.matchCodeName('ALARM_TYPE', item.alarmType)
                    })
                    this.tableData = res.result.pageList
                    this.pagination.total = res.result.total
					this.$store.commit('setHasNewAlarm',false)
                })
            },
			caseRed() {
			    this.$http.get(listAPI.caseRed).then(res => {
			        if(res.status === 200) {
			            let value = res.result.TOBEPROCESSED >= 99 ? '99+' : res.result.TOBEPROCESSED
			            let value1 = res.result.PROCESSING >= 99 ? '99+' : res.result.PROCESSING
			            this.$store.commit('setAlarmCount', {
			                name: 'pendingCount',
			                value,
			            })
			            this.$store.commit('setAlarmCount', {
			                name: 'processingCount',
			                value: value1,
			            })
			        }
			    })
			},
            getAlarmDetail(data) {
                this.$http.get(listAPI.datail + '?alarmId=' + data.id).then(res => {
                    this.dialogVisible = true
                    res.result.handlers.map(item => {
                        item.isOpen = false
                    })
                    this.alarmInfo = res.result
                })
            },
			goDetail(data) {
				this.$http.get(listAPI.datail + '?alarmId=' + data.id).then(res => {
					if(res.status==200){
						if(res.result.status==9){
							this.$message.error('该报警已取消！');
							this.$store.commit('setAlarmCount', {
								type: '',
								name: 'processingCount'
							})
							this.search();
						}else if(res.status==3){//误报
							this.$message.error('该报警是误报已取消！');
							this.caseRed();
							this.search();
						}else if(res.status==7){
							this.$message.error('该报警已完成！');
							this.caseRed();
							this.search();
						}else{
								localStorage.setItem('eventUserId', data.userId)
								sessionStorage.setItem('groupId', data.id)
								this.$store.commit('setAlarmId',data.id);
								sessionStorage.setItem('alarmInfo',JSON.stringify(res.result))
								this.$router.push({path: '/command/map'})
						}
					}else if(res.status==418){
						this.caseRed()
						this.search()
					}
				})
			},
            changeSwitch(node) {
                this.isDown = node
                this.search()
            },
            nodeClick(node) {
                this.searchParams.areaId = node.id;
				this.searchParams.page=this.pagination.page=1;
				this.areaId=node.id;
				this.search()
            },
			reset(){
				this.searchParams.page=this.pagination.page=1;
				this.searchParams.size=this.pagination.size=15;
				this.searchParams.areaId=this.areaId;
				this.searchParams.userId=sessionStorage.getItem('userId');
				this.searchParams.status='2';
				this.searchParams.search='';
				this.searchParams.date=[];
				this.search();
			},
        }
    }
</script>

<style scoped lang="less">
@import "processing";
</style>
